var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zhuangtaiStr)?_c('div',{staticClass:"liveing-pc",class:_vm.zhuangtaiCss},[_vm._v(" "+_vm._s(_vm.$t(_vm.zhuangtaiStr))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }